import { ensureInt } from "@/helpers/utility/Type";
import type { ItemStoreState } from "@editor/items/ItemStore";
import type { ActionItem } from "@editor/items/action/ActionItem";
import type { SimulationItem } from "@editor/items/simulation/SimulationItem";

export default {
  applyToVersions: "<2.6.1",
  type: "before",
  name: "add cost impulses",
  migrate(data: {
    simulations?: ItemStoreState<SimulationItem>;
    measures?: ItemStoreState<ActionItem>;
  }) {
    if (!data.simulations) return data;

    outer: for (const simId in data.simulations.items) {
      const simulation: SimulationItem = data.simulations.items[simId];

      for (const round of simulation.rounds) {
        const roundImpulses = round.impulses;

        // make sure all effects have an effect type
        let affectedType: "element" | "resource";
        for (affectedType in roundImpulses) {
          for (const affectedId in roundImpulses[affectedType]) {
            const impulse = roundImpulses[affectedType][affectedId];
            for (const sourceValue of impulse.sourceValues) {
              if (sourceValue.effectType) break outer;

              sourceValue.effectType = "effect";
            }
          }
        }

        // add activated measure costs to impulses
        for (const activatedMeasure of round.activatedMeasures) {
          for (const _resourceId in activatedMeasure.costs) {
            const resourceId = ensureInt(_resourceId);
            if (!roundImpulses.resource) roundImpulses.resource = {};
            if (!roundImpulses.resource[resourceId]) {
              roundImpulses.resource[resourceId] = {
                pointsToAdd: 0,
                sourceValues: []
              };
            }

            const impulse = roundImpulses.resource[resourceId];
            impulse.sourceValues.push({
              type: "measure",
              effectType: "cost",
              id: activatedMeasure.measureId,
              value: -activatedMeasure.costs[resourceId]
            });
          }
        }
      }
    }

    return data;
  }
};
